import React from 'react';
import PropTypes from 'prop-types';
import styles from './CustomDatePicker.module.css';
import calendarIcon from 'assets/images/icon_calender.png';

const CustomDatePicker = ({
  label,
  name,
  value,
  onChange,
  error,
  style,
  required = false,
  disabled = false,
}) => {
  return (
    <div className={styles.inputItem}>
      <label>
        {label}
        {required && <span className={styles.requiredIndicator}>*</span>}
      </label>
      <div className={`${styles.inputWrapper}`} style={style}>
        <div className={styles.inputWrapper}>
          <input
            type="date"
            name={name}
            min="1900-01-01"
            onChange={onChange}
            value={value}
            className={`
              ${value ? styles.dateHasValue : ''} 
              ${error ? styles.errorInput : ''} 
              ${disabled ? styles.disabledInput : ''}
            `}
            required={required}
            disabled={disabled}
          />
          <img
            src={calendarIcon}
            className={`${styles.calendarImage} ${disabled ? styles.disabledIcon : ''}`}
            alt="calendar"
          />
        </div>
        {error && <p className={styles.errorText}>{error}</p>}
      </div>
    </div>
  );
};

CustomDatePicker.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.string,
  style: PropTypes.object,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default CustomDatePicker;
